<template>
  <div>
    <el-card class="">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('upShopHouseManage.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="upShopHouseManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input
                v-model="upShopHouseManageInfo.conditions.personName"
                :placeholder="$t('upShopHouseManage.inputApplicant')"
                clearable
              />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input
                v-model="upShopHouseManageInfo.conditions.orderId"
                :placeholder="$t('upShopHouseManage.inputOrderNo')"
                clearable
              />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select
                v-model="upShopHouseManageInfo.conditions.state"
                :placeholder="$t('upShopHouseManage.selectStatus')"
                style="width:100%"
                clearable
              >
                <el-option
                  v-for="item in upShopHouseManageInfo.states"
                  :key="item.statusCd"
                  :label="item.name"
                  :value="item.statusCd"
                />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryShopHouseMethod">
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
            <el-button type="primary" size="small" @click="_resetShopHouseMethod">
              <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('upShopHouseManage.purchaseOrder') }}</div>
        <div class="ibox-tools">
          <el-button type="primary" size="small" @click="_openAddShopHouseModal">
            <i class="el-icon-plus"></i> {{ $t('upShopHouseManage.applyPurchase') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table
          :data="upShopHouseManageInfo.inoutOrders"
          border
          style="width: 100%"
        >
          <el-table-column prop="orderId" :label="$t('upShopHouseManage.orderNo')" align="center" />
          <el-table-column prop="prodName" :label="$t('upShopHouseManage.goods')" align="center" />
          <el-table-column prop="stateName" :label="$t('upShopHouseManage.status')" align="center" />
          <el-table-column prop="personName" :label="$t('upShopHouseManage.applicant')" align="center" />
          <el-table-column prop="createTime" :label="$t('upShopHouseManage.applyTime')" align="center" />
          <el-table-column prop="remark" :label="$t('upShopHouseManage.remark')" align="center" />
          <el-table-column :label="$t('common.operation')" align="center" width="200">
            <template #default="scope">
              <el-button
                v-if="scope.row.state=='1001' && hasPrivilege('502025011409820001')"
                type="text"
                size="small"
                @click="_openAuditModal(scope.row)"
              >
                {{ $t('common.audit') }}
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="_toDetail(scope.row)"
              >
                {{ $t('common.detail') }}
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="_deleteUpShopHouse(scope.row)"
              >
                {{ $t('common.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="upShopHouseManageInfo.conditions.page"
          :page-size="upShopHouseManageInfo.conditions.row"
          layout="total, prev, pager, next"
          :total="upShopHouseManageInfo.total"
        />
      </div>
    </el-card>

    <delete-inout-order ref="deleteInoutOrder" @refresh="_listInoutOrder" />
    <audit ref="audit" @notifyAuditInfo="_auditOrderState" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryInoutOrder, auditInoutOrder } from '@/api/goods/inoutOrderApi'
import DeleteInoutOrder from '@/components/goods/deleteInoutOrder'
import Audit from '@/components/common/audit'

export default {
  name: 'UpShopHouseManage',
  components: {
    DeleteInoutOrder,
    Audit
  },
  data() {
    return {
      upShopHouseManageInfo: {
        inoutOrders: [],
        total: 0,
        records: 1,
        states: [],
        conditions: {
          personName: '',
          orderId: '',
          orderType: '10000',
          state: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.upShopHouseManageInfo.conditions.shopId = getShopId()
    this._listInoutOrder()
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const {data} = await getDict('inout_order', 'state')
        this.upShopHouseManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listInoutOrder(page = 1, rows = 10) {
      this.upShopHouseManageInfo.conditions.page = page
      this.upShopHouseManageInfo.conditions.row = rows
      try {
        const res = await queryInoutOrder(this.upShopHouseManageInfo.conditions)
        this.upShopHouseManageInfo.total = res.total
        this.upShopHouseManageInfo.records = res.records
        this.upShopHouseManageInfo.inoutOrders = res.data
        console.log(this.upShopHouseManageInfo.records)
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAddShopHouseModal() {
      this.$router.push('/pages/goods/upShopHouseInManage')
    },
    _queryShopHouseMethod() {
      this._listInoutOrder()
    },
    _resetShopHouseMethod() {
      this.upShopHouseManageInfo.conditions = {
        personName: '',
        orderId: '',
        orderType: '10000',
        state: '',
        shopId: getShopId(),
        page: 1,
        row: 10
      }
      this._listInoutOrder()
    },
    _deleteUpShopHouse(row) {
      this.$refs.deleteInoutOrder.open(row)
    },
    _openAuditModal(row) {
      this.upShopHouseManageInfo.curOrder = row
      this.$refs.audit.open()
    },
    async _auditOrderState(auditInfo) {
      const order = this.upShopHouseManageInfo.curOrder
      order.state = auditInfo.state
      order.stateRemark = auditInfo.remark
      order.shopId = getShopId()
      try {
        await auditInoutOrder(order)
        this._listInoutOrder()
        this.$message.success(this.$t('common.auditSuccess'))
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    _toDetail(row) {
      this.$router.push(`/pages/goods/upShopHouseDetail?orderId=${row.orderId}`)
    },
    handleCurrentChange(val) {
      this._listInoutOrder(val)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 15px 7px;
}
.ibox-content {
  padding: 15px;
}
</style>